import axios from 'axios';

const url = 'https://servicodados.ibge.gov.br/api/v1';

class IBGE {
  async buscarCidades(uf) {
    return await axios
      .get(`${url}/localidades/estados/${uf}/municipios?orderBy=nome`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        console.log(err);
        return [];
      });
  }
}

export default new IBGE();
